import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

// import urlJoin from "url-join";

const BrandVerticalsSection = "/reports/omi/brand-vertical";

export const BrandVerticalsListPath = BrandVerticalsSection;

export enum BrandVerticalListUrlFiltersEnum {
  query = "query"
}

export enum BrandVerticalListUrlFiltersWithMultipleValues {
  brandStatus = "brandStatus",
  vertical = "vertical"
}
export type BrandVerticalListUrlDialog =
  | "add"
  | "view-store"
  | "assign"
  | "download"
  | TabActionDialog;
export type BrandVerticalListUrlFilters = Filters<
  BrandVerticalListUrlFiltersEnum
> &
  FiltersWithMultipleValues<BrandVerticalListUrlFiltersWithMultipleValues>;

export type BrandVerticalListUrlQueryParams = ActiveTab &
  BrandVerticalListUrlFilters &
  BulkAction &
  Dialog<BrandVerticalListUrlDialog> &
  Pagination &
  SingleAction;

export const BrandVerticalListUrl = (
  params?: BrandVerticalListUrlQueryParams
) => BrandVerticalsListPath + "?" + stringifyQs(params);
